module.exports = __webpack_public_path__ + "static/img/page24.85d7359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page24.jpg
// module id = 1etJ
// module chunks = 0